module.exports = "https://static.energy5.com/_next/static/images/sliderRetail-853bbcb45ff93bf185bc42282ce7339e.webp";